<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="8">
        <div class="text-h5">{{ user.name }}</div>
        <v-container>
          <v-row>
            <v-card flat tile class="pa-2">
              <v-icon small color="indigo">
                account_box
              </v-icon>&nbsp;{{ user.uid }}
            </v-card>
            <v-card flat tile class="pa-2">
              <v-icon small color="indigo">
                email
              </v-icon>&nbsp;
                <span v-if="user.email">{{ user.email.split('@')[0] }}</span>
              </v-card>
            </v-row>
        </v-container>
      </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="8">

          <v-card :shaped="false" :elevation="3" color="grey darken-4">

           <v-simple-table>
               <template v-slot:default>
                 <thead>
                   <tr>
                     <th v-if="user.isAdmin" class="text-left">Pd</th>
                     <th class="text-left">Course</th>
                     <th class="text-left">Name</th>
                     <th class="text-left">Instructor</th>
                     <th  v-if="user.isAdmin" class="text-left">Students</th>
                   </tr>
                 </thead>
                 <tbody>
                   <tr v-for="item in classes" :key="item.uid">
                     <td v-if="user.isAdmin"  style="font-size:.8em" class="text-xs">
                       {{ item.band }}
                     </td>
                     <td style="font-size:.8em" class="text-xs">
                       {{ item.uid }}
                     </td>
                     <td style="font-size:.8em" class="text-xs">
                       {{ item.name }}
                       <!-- <router-link :to="'/class/' + item.uid">{{ item.name }}</router-link> -->
                     </td>
                     <td  style="font-size:.8em" class="text-xs">
                       <div v-for="teacher in item.teachers.split(',')" :key="teacher">
                         {{ teacher.split("@")[0] }}
                       </div>
                     </td>
                     <td   v-if="user.isAdmin" style="font-size:.8em" class="text-xs">
                       {{ item.num_students }}
                     </td>
                   </tr>
                 </tbody>
               </template>
             </v-simple-table>
          </v-card>
        </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="8">
      <v-card :shaped="false" :elevation="3" color="grey darken-4 mt-10">
       <v-simple-table>
           <template v-slot:default>
             <thead>
               <tr>
                 <th class="text-left">Item/Book</th>
                 <th class="text-left">Name</th>
                 <th class="text-left">Assigned</th>
                 <th class="text-left">Status</th>

               </tr>
             </thead>
             <tbody>
               <tr v-for="item in inventory.items" :key="item.uid">
                 <td style="font-size:.8em" class="text-xs">
                   {{ item.uid }}
                 </td>
                 <td style="font-size:.8em" class="text-xs">
                   {{ item.name }}
                   <div style="font-size:.9em;color:grey">
                    {{ item.category }} /{{ item.asset_type }}
                   </div>
                 </td>
                 <td  style="font-size:.8em" class="text-xs">
                  {{ item.when_assigned }}
                 </td>
                 <td  style="font-size:.8em" class="text-xs">
                  {{ item.status }}
                 </td>
               </tr>
             </tbody>
           </template>
         </v-simple-table>
      </v-card>
    </v-col>
  </v-row>
  </v-container>
</template>

<script>
const api = require('../apiFunctions.js')
const fb = require('../firebaseConfig.js')
const moment = require('moment')

function sanitize(s) {
  return s.replace(/[^a-z]/gi, '');
}

export default {

  data: () => ({
    user: fb.session.user,
    tab:null,
    userKey: '',
    params: {
      meetCode: '',
      target: '',
      table: '',
      limit: 100
    },
    today: moment().format("YYYY-MM-DD"),
    selectedMeetingDate: 'Today',
    filterDate: new Date(),
    classes: [],
    inventory: {
      items: [],
      search: '',
      table:{
        headers: [
          { text: 'Date', value: 'time' },
          { text: 'Meeting Code', value: 'meeting_code' },
          { text: 'Num Persons', value: 'num_attendees' },
          { text: 'Host', value: 'organizer_email' },
          { text: 'Start Time', value: 'start_time' },
          { text: 'End Time', value: 'end_time' },
          { text: 'Duration', value: 'duration_seconds' },
          { text: ''}
        ]
      }
    }
  }),
  watch: {
    'userKey' (uid) {
      this.getMyClasses()
    },
    '$route' (to, from) {
      let params = to.params
      if (params.userKey) {
        this.userKey = params.userKey
      } else {
        this.userKey = fb.session.user.username
      }
    }
  },
  mounted () {
    let params = this.$route.params
    if (params.userKey) {
      this.userKey = params.userKey
      this.getAccount()
    } else {
      this.userKey = fb.session.user.username
    }
  },
  methods: {
    getStudentCirculationItems: function (uid) {
      var self = this;
      api.get('getStudentCirculationItems', {student_uid:uid}, (data) => {
        console.log('circulation', data)
        self.inventory.items = data
      })
    },
    getAccount: function () {
      var self = this
      api.students.get({email:self.userKey}, (data) => {
        console.log(data)
        self.user = data[0]
        self.getStudentCirculationItems(self.user.uid)
      })
    },
    getMyClasses: function () {
      var self = this

      if (this.userKey && this.userKey != fb.session.user.username) {
        api.get('myClasses', {userKey: this.userKey}, (data) => {
          console.log(data)
          self.classes = data
        })
      } else {
        self.user.getClasses.then( (data)=>{
            console.log(data)
            self.classes = data
        })
      }
    }
  }
}
</script>
